/* eslint-disable no-script-url,jsx-a11y/anchor-is-valid */
import React from "react";

export function HeaderMenu({ layoutProps }) {

    return <div
        id="kt_header_menu"
        className={`header-menu header-menu-mobile ${layoutProps.ktMenuClasses} align-items-center`}
        {...layoutProps.headerMenuAttributes}
    >
        <h3 style={{margin: 0}}>APL Return</h3>
    </div>;
}
